import { darken } from 'polished';
import { DropdownIndicatorProps, GroupBase, components } from 'react-select-5';

import ArrowUp from 'components/shared/Icon/icons/ArrowUp';

export const DropdownIndicator = function <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: DropdownIndicatorProps<Option, IsMulti, Group>,
) {
  return (
    <components.DropdownIndicator {...props}>
      <ArrowUp
        fill={props.isFocused ? darken(0.2, '#4995ec') : '#3E3E40'}
        width="1.4rem"
        height="1.4rem"
        style={{ transform: 'rotate(180deg)' }}
      />
    </components.DropdownIndicator>
  );
};
